import React from "react";
import { OrganizationOverview } from "../../../../../client/types.gen";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { RowButton } from "./RowButton";
import { getImageUrl } from "../../../../../utils/image";
import vocsLogo from "../../../../../assets/vocs-logo.png";
import { organizationInfoState } from "../../../../../state/organizationInfo";
import { contactInfoSalesContactState } from "../../../../../state/contactInfoSalesContact";
import defaultIconLogo from "../../../../../assets/frog_logo.png";
import { homeState } from "../../../../../state/home";

interface OrganizationProfileProgressProps {
  organization: OrganizationOverview;
  showDefaultLeadSettings: boolean;
}

const calculateProgress = (
  org: OrganizationOverview,
): { completed: number; total: number; percentComplete: number } => {
  let completed = 0; // Name always exists
  const total = 9;

  // Basic Information (2 fields: name, website, shortDesc)
  if (org.website) completed++;
  if (org.shortDesc) completed++;

  // Branding (4 fields: logoId, iconLogoId, primaryColor, secondaryColor)
  if (org.logoId) completed++;
  if (org.iconLogoId) completed++;
  if (org.primaryColor) completed++;
  if (org.secondaryColor) completed++;

  // Contact Information (3 fields: email, phoneNumber, salesContact)
  if (org.email) completed++;
  if (org.phoneNumber) completed++;
  if (org.salesContact) completed++;

  const percentComplete = Math.round((completed * 100) / total);

  return { completed, total, percentComplete };
};

export const OrganizationProfileProgress: React.FC<
  OrganizationProfileProgressProps
> = ({ organization, showDefaultLeadSettings }) => {
  const { completed, total, percentComplete } = calculateProgress(organization);

  return (
    <div className="min-h-[228px]">
      <div className="flex flex-row w-full items-center gap-2 h-full">
        <div className="w-full bg-gray-200 rounded-full h-2 overflow-hidden">
          <div
            className="bg-red-500 h-full transition-all duration-300 rounded-full"
            style={{ width: `${percentComplete}%` }}
          />
        </div>
        <div className="h-full flex items-center justify-center">
          <span className="text-sm font-semibold text-gray-700">
            {completed}
            <span className="text-gray-400">/{total}</span>
          </span>
        </div>
      </div>

      <div className="mt-3">
        <RowButton
          imageUrl={
            organization.iconLogoId
              ? getImageUrl(organization.iconLogoId)
              : defaultIconLogo
          }
          title="Company"
          description="Add logo, colours and more"
          onClick={() => {
            organizationInfoState.showOrganizationInfo = true;
          }}
        />
        <RowButton
          icon={faUser}
          iconBgColor="bg-red-100"
          iconColor="text-red-500"
          title="Contact"
          description="Add email, phone and more"
          onClick={() => {
            contactInfoSalesContactState.showContactInfoSalesContact = true;
          }}
        />
        {showDefaultLeadSettings === true ? (
          <RowButton
            imageUrl={getImageUrl("bba54c42-4717-4a7c-861b-77ee7a5a3a18")}
            iconBgColor="bg-red-100"
            iconColor="text-red-500"
            title="Profile Version Template"
            description=""
            onClick={() => {
              homeState.linkCreatorLeadId = organization.defaultLeadId ?? "";
              homeState.linkCreatorIsDefaultLead = true;
            }}
          />
        ) : null}
      </div>
    </div>
  );
};
